export default "__VITE_ASSET__595e7d8b__"